import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { AnnouncementBanner } from "@/components/AnnouncementBanner";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { RecruitTicker } from "@/components/RecruitTicker";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export function PublicLayout({ children }) {
  return (
    <div className="flex min-h-screen flex-col bg-brand-bg">
      <ScrollToTop />
      <div className="sticky top-0 z-50">
        <RecruitTicker />
        <AnnouncementBanner />
        <Navbar />
      </div>
      <main className="flex-1">{children}</main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

// Reusable page header band
export function PageHero({ eyebrow, title, subtitle, children }) {
  return (
    <section className="relative overflow-hidden bg-brand-blue noise-overlay">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        {eyebrow && <p className="eyebrow text-brand-teal2 mb-3">{eyebrow}</p>}
        <h1 className="max-w-4xl font-heading text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">{title}</h1>
        {subtitle && <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-300 md:text-lg">{subtitle}</p>}
        {children}
      </div>
    </section>
  );
}
